import { createSlice } from '@reduxjs/toolkit';
const locationSlice = createSlice({
  name: 'locations',
  initialState: {
    locations: [],
    cities: [],
    loading: false,
    error: null
  },
  reducers: {
    // Set locations after fetching
    setLocations: (state, action) => {
      state.locations = action.payload.map(location => ({
        ...location,
        cities: location.cities.map(city => ({
          ...city,
          isActive: city.isActive || city.is_active // Handle both API and Redux formats
        }))
      }));
      state.loading = false;
      state.error = null;
    },
    
    // Set cities
    setCities: (state, action) => {
      state.cities = action.payload;
      state.loading = false;
      state.error = null;
    },
    
    // Add a city
    addCity: (state, action) => {
      state.cities.push(action.payload);
    },
    
    // Update a city
    updateCity: (state, action) => {
      const index = state.cities.findIndex(city => city.id === action.payload.id);
      if (index !== -1) {
        state.cities[index] = action.payload;
      }
    },
    
    // Delete a city
    removeCity: (state, action) => {
      state.cities = state.cities.filter(city => city.id !== action.payload);
    },
    
    // Toggle city status
    toggleCityStatus: (state, action) => {
      const { id, isActive } = action.payload;
      const city = state.cities.find(city => city.id === id);
      if (city) {
        city.isActive = isActive;
      }
    },
    
    // Toggle location status
    toggleLocationStatus: (state, action) => {
      const { id, status } = action.payload;
      const location = state.locations.find(loc => loc.id === id);
      if (location) {
        location.status = status;
      }
    },
    
    // Add new location
    addLocation: (state, action) => {
      state.locations.push(action.payload);
    },
    
    // Remove location
    removeLocation: (state, action) => {
      state.locations = state.locations.filter(loc => loc.id !== action.payload);
    },
    
    // Update location
    updateLocation: (state, action) => {
      const index = state.locations.findIndex(loc => loc.id === action.payload.id);
      if (index !== -1) {
        state.locations[index] = action.payload;
      }
    },
    
    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    
    // Set error state
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export const { 
  setLocations,
  setCities,
  addCity,
  updateCity,
  removeCity,
  toggleCityStatus,
  toggleLocationStatus, 
  addLocation,
  updateLocation,
  removeLocation,
  setLoading,
  setError 
} = locationSlice.actions;

export default locationSlice.reducer;
